type DotLottiePlayerImport = () => Promise<unknown>;
type DotLottiePlayerLoader = () => Promise<void>;

export const createDotLottiePlayerLoader = (
  importPlayer: DotLottiePlayerImport
): DotLottiePlayerLoader => {
  let playerLoadPromise: Promise<void> | null = null;

  return () => {
    if (typeof window === "undefined") return Promise.resolve();

    if (!playerLoadPromise) {
      playerLoadPromise = importPlayer()
        .then(() => undefined)
        .catch(() => {
          // Decorative only; there is nothing to recover and nothing worth reporting.
        });
    }

    return playerLoadPromise;
  };
};

/*
 * Registers the `<dotlottie-player>` custom element on the client.
 *
 * Fire-and-forget by design: the player only drives decorative animations, so
 * the page stays fully functional if the chunk never arrives. The shared
 * promise keeps every dotlottie surface behind one import path.
 */
export const loadDotLottiePlayer = createDotLottiePlayerLoader(
  () => import("@dotlottie/player-component/dist/dotlottie-player.js")
);
